

































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  Scheme,
  SchemeType,
  Asset,
  NormalScheme
} from "@foxone/api/src/models/defi";
import utils from "defi/utils";

@Component
class SchemeIntroduction extends Vue {
  @Prop()
  scheme!: Scheme | null;

  fullmode = false;

  get meta() {
    const scheme = this.scheme;
    const getProgressMeta = utils.enums.getSchemeProgressMeta;
    const getColor = this.$common.utils.helper.getColor;

    let interestRatio = "0";
    if (scheme && scheme?.type !== SchemeType.POOL) {
      interestRatio = scheme?.interest_ratio;
    }

    let status = { text: "", color: "" };
    if (scheme) {
      status = getProgressMeta(scheme?.progress);
    }

    let asset: Asset | undefined;
    if (scheme?.type === SchemeType.DUAL_NODE) {
      asset = scheme.slave_asset;
    } else {
      asset = (scheme as NormalScheme)?.pay_asset;
    }

    const rate =
      +interestRatio === 0
        ? this.$t("common.tbd")
        : this.$common.utils.number.toPercent(interestRatio, true);
    return {
      rate,
      status,
      image: asset?.icon,
      name: asset?.name,
      symbol: asset?.symbol.toUpperCase(),
      rateColor: getColor(this.$store, interestRatio),
      description: scheme?.description
    };
  }

  toggleFullMode() {
    this.fullmode = !this.fullmode;
  }
}
export default SchemeIntroduction;
